import { render, staticRenderFns } from "./LeadCancelDialog.vue?vue&type=template&id=126a00c4"
import script from "./LeadCancelDialog.vue?vue&type=script&lang=ts"
export * from "./LeadCancelDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports